import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Login } from 'shared/pages/login/Login';

export function PublicRoutesHandler() {
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Redirect from="/" exact to="/login" />
      <Redirect from="*" exact to="/login" />
    </Switch>
  );
}
